import React, { useState } from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import bgImg2 from '../assets/side_image_f.jpg';
import bgImg1 from '../assets/female_fertility_img_2.png';
import "./FemaleFertilityContent.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen } from '@fortawesome/free-solid-svg-icons';

const FemaleFertilityContent = () => {
    const [showContent, setShowContent] = useState('');
  
    const toggleContent = (content) => {
      setShowContent(showContent === content ? '' : content);
    };

  return (
    <div className='my-32' style={{ marginLeft: "30px"  }}>

    <div className='grid md:grid-cols-2 gap-1 px-2 text-center who_font_style'>
        <div className=' w-full transform hover:translate-x-2 transition duration-300 ease-in-out' style={{ marginTop: "35px"  }}>
            <img className='w-half' src={bgImg1} alt="/" />
        </div>
        <div className='text-lg text-gray-700 mt-8 text-left'style={{ marginLeft: "25px"  }}>
        <h1 className='female_sub_heading'style={{ marginLeft: "25px"  }}>
            What we offer
        </h1>
        <p className='mt-12'>
        It can be real a life-changer when you know, or start to <br />suspect that your journey to parenthood 
        will be more <br />complex than expected. Whether you are a single<br /> woman, a heterosexual couple or a 
        same-sex couple,<br /> at King’s Fertility we will stand with you on every step<br /> along the journey to life. 
        From your first fertility consultation,<br /> we will get to know your specific needs and requirements,<br /> 
        and together we will build a tailored treatment plan that <br />we believe would give you the highest chance of success.
        </p>

        </div>

    </div>
    <div className='grid md:grid-cols-2 gap-1 px-2 text-left who_font_style mt-24'>
        <div className='mt-2'style={{ marginRight: "40px"  }}>
            <h1 className='female_sub_heading'>
            Primary Factors Contributing To Female Infertility
            </h1>
            <h3 className='mt-12'>
                Damage or blockage to fallopian tubes:
            </h3>
            <p className='text-lg text-gray-700 mt-4'>
            When the passage for eggs is obstructed or impaired in the fallopian tubes, it disrupts the meeting of sperm 
            and egg necessary for conception. This blockage can occur due to various factors, 
            including pelvic infections or scarring.
            </p>
            <h3 className='mt-12'>
            Hormonal causes:
            </h3>
            <p className='text-lg text-gray-700 mt-4'>
            Some women experience challenges with ovulation due to hormonal imbalances. When the coordinated 
            hormonal changes required for egg release and the preparation of the uterine lining don't happen as 
            expected, it can signal ovulation issues. These concerns can be identified through methods such as ovulation 
            predictor kits, basal body temperature tracking, or blood tests to assess hormone levels. Follicular or ovulation 
            studies gauge follicle health and size to predict ovulation patterns.

            </p>
            <h3 className='mt-12'>
            Cervical causes:
            </h3>
            <p className='text-lg text-gray-700 mt-4'>
            Certain cervical conditions may impede sperm passage through the cervical canal. 
            This could result from prior surgeries or abnormal mucus production, creating obstacles to fertilization.
            </p>
            <h3 className='mt-12'>
            Uterine causes:
            </h3>
            <p className='text-lg text-gray-700 mt-4'>
            Anomalies in the structure of the uterus, such as the presence of fibroids or
             polyps, might interfere with successful conception.
            </p>
            <h3 className='mt-12'>
            Unexplained infertility:
            </h3>
            <p className='text-lg text-gray-700 mt-4'>
            Despite extensive investigations, approximately 20% of couples face unexplained 
            infertility where the root cause cannot be identified using current diagnostic methods.
            </p>
        </div>
        <div className=' w-full transform hover:translate-x-2 transition duration-300 ease-in-out' style={{ marginTop: "15px"  }}>
        <img className='w-half' src={bgImg2} alt="/" />
        </div>
    </div>
    <div className='grid md:grid-cols-1 gap-1 px-2 text-left who_font_style mt-2'>
        <div className='mt-2'style={{ marginRight: "40px"  }}>
            <h3 className='mt-12'>
            Failure to Ovulate:
            </h3>
            <p className='text-lg text-gray-700 mt-4'>
            Ovulation disorders remain a common barrier to conception for many women. Fortunately, various treatments, 
            including herbal and mineral-based Ayurvedic medicines, have shown promise in addressing these challenges 
            effectively.
            </p>
        </div>
    </div>
    <div className='grid md:grid-cols-1 gap-1 px-2 text-left who_font_style mt-2'>
        <div className='mt-2'style={{ marginRight: "40px"  }}>
            <h3 className='mt-12'>
            A Hope for IVF failure
:
            </h3>
            <p className='text-lg text-gray-700 mt-4'>
            The success rate of in vitro fertilization (IVF) can vary depending on factors such as age, reproductive health, and clinic-specific protocols. Generally, the success rate for IVF ranges from around 20% to 40% per cycle for women under 35, but it decreases with age. It's important to consult with a fertility specialist for personalized information.<br />
            Finding Hope After IVF Failure: A Journey with Newhope Infertility Herbal CareFacing infertility and experiencing unsuccessful attempts at in vitro fertilization (IVF) can be emotionally devastating for individuals and couples longing to start a family. However, amidst the despair, there is still hope, especially for those seeking alternative avenues for conception, such as Newhope Infertility Herbal Care.At Newhope Infertility Herbal Care, patients are welcomed into an environment of compassion, understanding, and dedication to helping them achieve their dreams of parenthood. While conventional IVF treatments may have fallen short, Newhope offers a beacon of hope through its holistic approach, incorporating herbal remedies alongside medical interventions.For patients who have endured the heartache of IVF failure, Newhope provides a renewed sense of optimism. Through personalized treatment plans tailored to individual needs, patients are guided on a journey towards fertility restoration. The clinic's emphasis on herbal care not only addresses physical imbalances but also nurtures the emotional well-being of patients, offering solace and encouragement during what can be a tumultuous time.Hope flourishes as patients witness the dedication of the skilled practitioners at Newhope, who tirelessly work towards maximizing their chances of conception. The integration of herbal medicine complements conventional fertility treatments, offering a holistic approach that considers the whole person, not just their reproductive system.Moreover, Newhope Infertility Herbal Care instills hope by fostering a supportive community among patients. Sharing experiences, triumphs, and setbacks with others on a similar journey creates a sense of solidarity and empowerment. Together, patients find strength in unity and draw inspiration from one another's resilience.While the path to parenthood may be fraught with challenges, Newhope Infertility Herbal Care instills unwavering hope in its patients. With each step forward, guided by the expertise and compassion of the clinic's practitioners, individuals and couples find solace in knowing that they are not alone in their pursuit of parenthood. Through perseverance, faith, and the transformative power of herbal care, hope is reignited, paving the way for new beginnings and the realization of long-held dreams
            </p>
        </div>
    </div>
    <div className='grid md:grid-cols-1 gap-1 px-2 text-left who_font_style mt-20'>
    <h1 className='female_sub_heading'style={{ marginLeft: "25px"  }}>
            Additional Factors
        </h1>
        <div className='mt-2 ' style={{ marginRight: "40px" }}>
          <h3 className='mt-12 ovulation_heading' onClick={() => toggleContent('ovulation')}>
          Array of Factors Impacting Women's Fertility (read more)<FontAwesomeIcon icon={faFolderOpen} className="shake" />
          </h3>
          {showContent === 'ovulation' && (
            <p className='text-lg text-gray-700 mt-4 ovulation_content'>
              Female infertility can stem from diverse uterine conditions, affecting approximately 10% of cases, such as fibroids, 
              polyps,and adenomyosis. These conditions often lead to blockages in the Fallopian tubes and the uterus, hindering 
              conception. Congenital abnormalities like a septate uterus can result in recurrent miscarriages or difficulties in 
              conceiving. Additionally, around 3% of couples face infertility issues attributed to abnormalities in the female cervical
               mucus. The consistency and quantity of cervical mucus play a vital role in facilitating sperm movement, 
              with hormonal imbalances, notably insufficient estrogen or excessive progesterone, being common culprits for 
              irregular cervical mucus.
            </p>
          )}
        <h3 className='mt-12 ovulation_heading' onClick={() => toggleContent('ovulation')}>
        Impact of Personal Behaviors (read more)<FontAwesomeIcon icon={faFolderOpen} className="shake" />
          </h3>
          {showContent === 'ovulation' && (
            <p className='text-lg text-gray-700 mt-4'>
             Various lifestyle factors and personal habits can significantly influence health and, in turn, impact a couple's 
             ability to conceive. Nevertheless, proactive regulation of these factors can enhance both fertility and overall well-being.
              Taking control of lifestyle choices can notably improve the chances of conceiving while promoting 
              better health outcomes for individuals.<br />
              Maintaining a balanced diet and regular exercise is crucial for optimal reproductive health. Both underweight and 
              overweight conditions in women can pose challenges in conceiving. Smoking significantly lowers sperm counts in men 
              and increases the risk of miscarriage, premature birth, and low-birth-weight babies in women, reducing natural conception
               chances as well as impacting IVF success rates. Alcohol intake during pregnancy can result in birth defects or even 
               Foetal Alcohol Syndrome, while also affecting sperm counts in men. Anabolic steroids and substances like marijuana 
               affect male sperm counts, and drug use during pregnancy, such as cocaine, can lead to severe 
              complications in babies, emphasizing the importance of avoiding recreational drugs when trying to 
              conceive or during pregnancy.
            </p>
          )}
        <h3 className='mt-12 ovulation_heading' onClick={() => toggleContent('ovulation')}>
        Effects of Environmental Toxins on Fertility and Diagnostic Approaches (read more)<FontAwesomeIcon icon={faFolderOpen} className="shake" />
          </h3>
          {showContent === 'ovulation' && (
            <p className='text-lg text-gray-700 mt-4'>
              Exposure to environmental toxins and workplace chemicals can impact fertility, leading to mutations, birth defects, 
              abortions, or reproductive issues known as reproductive toxins. Work-related diseases, including infertility, spontaneous 
              abortion, and teratogenesis, rank among the top ten globally. In healthy women, infertility may arise from inadequate
               ovulation, hormonal imbalances, or tubal blockages. Diagnostic tests such as ultrasound scans of the pelvis and abdomen 
               help identify uterine or ovarian diseases, while HSG detects fallopian 
              tube issues. Ovulation or follicular studies assess follicle size, ovulation, and rupture, aiding in fertility evaluation.
            </p>
          )}
        </div>
      </div>
      <div className='grid md:grid-cols-1 gap-1 px-2 text-left who_font_style mt-20'>
        <div className='mt-2'style={{ marginRight: "40px"  }}>
            <h1 className='female_sub_heading'style={{ marginLeft: "25px"  }}>
            Endometriosis and Fertility
            </h1>
            <p className='text-lg text-gray-700 mt-4'>
            Endometriosis, a condition characterized by the abnormal growth of the endometrial tissue outside the uterus, 
            significantly affects a woman's ability to conceive. Studies suggest that endometriosis reduces the chances of 
            conception by 12 to 36% in affected women.
            </p>
            <p className='text-lg text-gray-700 mt-4'>
            This condition involves the excessive growth of the endometrium, typically found lining the uterus, in other 
            areas of the abdomen. These growths might occur on organs like the ovaries, fallopian tubes, or the peritoneum 
            of the pelvis.
            </p>
            <p className='text-lg text-gray-700 mt-4'>
            Diagnosis of endometriosis often involves procedures such as diagnostic laparoscopy. This allows physicians 
            to visually inspect and evaluate the condition of organs within the abdomen, including the uterus and 
            fallopian tubes.
            </p>
            <p className='text-lg text-gray-700 mt-4'>
            Symptoms associated with endometriosis vary widely, ranging from heavy and painful menstrual periods
             to urinary urgency, premenstrual spotting, rectal bleeding, or, in some cases, 
             no symptoms at all.
            </p>
            <p className='text-lg text-gray-700 mt-4'>
            Interestingly, despite its impact on fertility, long-term cumulative pregnancy rates appear to remain normal 
            in patients with minimal endometriosis and normal reproductive anatomy..
            </p>
        </div>
    </div>
    </div>
  );
};



export default FemaleFertilityContent;